import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '../../../../../styledComponents/styles/Paragraph.styled';
import StarRating from '../../../../../styledComponents/styles/StarRating.styled';

const Container = styled.div`
  font-family: 'Nunito', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0.015em;
  color: #373737;
`;

const InputContainer = styled.div`
  flex: 1;
  margin: 13px 0;
  text-align: left;
`;

const Label = styled.label`
  color: ${({ theme }) => theme.textInput.label.fontColor};
  font-family: ${({ theme }) => theme.textInput.label.fontFamily};
  font-size: ${({ theme }) => theme.textInput.label.fontSize};
  font-weight: ${({ theme }) => theme.textInput.label.fontWeight};
`;

const Required = styled.span`
  color: ${({ theme }) => theme.defaults.errorColor};
  padding-left: 5px;
`;

export default function QuestionStarRatingDisplayPreview({ question }) {
  const id = question.question_id.toString();
  const updatedInstructions = !!question.instructions ? question.instructions.replace(/<p><\/p>/g, '<br />') : '';
  return (
    <Container>
      <InputContainer>
        <Label htmlFor={question.id}>
          {question.label}
          {question.required && <Required>*</Required>}
        </Label>
        <Paragraph
          aria-label={question.label}
          id={'star-rating-instructions'}
          openSans
          dangerouslySetInnerHTML={{
            __html: updatedInstructions,
          }}
        />

        <StarRating
          id={id}
          disabled
          maxStars={question.star_rating_question_options.length}
          options={question.star_rating_question_options.reduce(
            (a, key, index) => Object.assign(a, { [index + 1]: key.name }),
            {},
          )}
        />
      </InputContainer>
    </Container>
  );
}
